import { Box, Button } from "@mui/material";
import React from "react";

function CustomButton({ children, variant, color, Icon, size, onClick }) {
  return (
    <Button
      variant={variant}
      size={size}
      style={{ color: color, borderColor: color }}
      onClick={onClick}
    >
      {Icon} <span style={{ marginLeft: Icon ? "5px" : 0 }}>{children}</span>
    </Button>
  );
}

export default CustomButton;
